import { Directive, HostListener } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';

@Directive({
    selector: '[appNavigateToFirstPageOnSort]',
    standalone: false
})
export class NavigateToFirstPageOnSortDirective {
  constructor(private readonly host: DxDataGridComponent) { }

  @HostListener('onOptionChanged', ['$event']) onGridOptionChanged(e) {
    if (e.fullName.indexOf('sortOrder') !== -1) {
      setTimeout(() => {
        this.host.instance.pageIndex(0);
      }, 200);
    }
  }
}
